import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.modalShow)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.modalShow,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalShow) = $event)),
        width: "1000",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { "primary-title": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("message.normalizedScoresFunctions")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.ncalcMessage")), 1),
                  _createVNode(_component_v_table, { density: "compact" }, {
                    default: _withCtx(() => [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[2] || (_cache[2] = _createElementVNode("th", { class: "text-left" }, null, -1)),
                          _createElementVNode("th", _hoisted_1, _toDisplayString(_ctx.$t("message.title")), 1),
                          _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t("message.expression")), 1),
                          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("message.weight")), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalizedScoresFunctions, (f, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_icon, {
                                onClick: ($event: any) => (_ctx.removeLine(f))
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("mdi-delete-circle-outline", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_text_field, {
                                modelValue: f.title,
                                "onUpdate:modelValue": ($event: any) => ((f.title) = $event),
                                class: "parameterText",
                                "hide-details": "",
                                flat: "",
                                "single-line": "",
                                variant: "solo",
                                "full-width": "",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_text_field, {
                                modelValue: f.function,
                                "onUpdate:modelValue": ($event: any) => ((f.function) = $event),
                                class: "parameterText",
                                "hide-details": "",
                                flat: "",
                                "single-line": "",
                                variant: "solo",
                                "full-width": "",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_text_field, {
                                modelValue: f.weight,
                                "onUpdate:modelValue": ($event: any) => ((f.weight) = $event),
                                class: "parameterNumber",
                                "hide-details": "",
                                flat: "",
                                "single-line": "",
                                variant: "solo",
                                "full-width": "",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_icon, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addLine()))
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-plus-circle-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panels, { style: {"margin-top":"1em"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                    _createTextVNode("mdi-code-json", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[6] || (_cache[6] = _createTextVNode(" JSON", -1))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("pre", null, _toDisplayString(this.encode()), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _ctx.save
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.save")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _ctx.close
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}